
import { createSlice } from "@reduxjs/toolkit";
import { fetchDispatchIssueToLabourList, fetchDispatchIssueToLabourById } from "./thunk";

interface ReadyForDispatchState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedIssue: any | null;
  loadingSelected: boolean;
}

const initialState: ReadyForDispatchState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedIssue: null,
  loadingSelected: false,
};

const DispatchIssueToLabourSlice = createSlice({
  name: "DispatchIssueToLabourSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDispatchIssueToLabourList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchDispatchIssueToLabourList.fulfilled, (state, action) => {
        state.loading = false;
        state.error = null;
        // Handle both structured response and direct array response
        if (action.payload && typeof action.payload === 'object') {
          const payload = action.payload as any;
          state.list = Array.isArray(payload.data) 
            ? payload.data 
            : Array.isArray(payload) 
            ? payload 
            : [];
          state.rowCount = payload.rowCount || payload.count || 0;
        } else {
          state.list = [];
          state.rowCount = 0;
        }
      })
      .addCase(fetchDispatchIssueToLabourList.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message ||
          "Failed to fetch Dispatch List";
      })
      .addCase(fetchDispatchIssueToLabourById.pending, (state) => {
        state.loadingSelected = true;
        state.error = null;
      })
      .addCase(fetchDispatchIssueToLabourById.fulfilled, (state, action) => {
        state.loadingSelected = false;
        state.error = null;
        state.selectedIssue = action.payload;
      })
      .addCase(fetchDispatchIssueToLabourById.rejected, (state, action) => {
        state.loadingSelected = false;
        state.error =
          action.error.message ||
          "Failed to fetch Issue To Labour details";
        state.selectedIssue = null;
      });
  },
});

export default DispatchIssueToLabourSlice.reducer;
